function PageIcon() {
	return (
		<svg width="30" height="40" viewBox="0 0 38 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.30127 1.54413H23.9663C24.1077 1.54418 24.2433 1.60042 24.3433 1.70038L36.9331 14.2902C37.033 14.3901 37.0892 14.5259 37.0894 14.6672V42.6642C37.0894 44.7581 35.3922 46.4562 33.2983 46.4562H5.30127C3.20748 46.4562 1.51025 44.758 1.51025 42.6642V5.33514C1.51034 3.24141 3.20754 1.54421 5.30127 1.54413Z"
				fill="white"
				stroke="#D5D7DA"
				strokeWidth="1.74981"
			/>
			<path
				d="M23.9658 1.25238V10.0015C23.9658 12.5785 26.0549 14.6676 28.632 14.6676H37.3811"
				stroke="#D5D7DA"
				strokeWidth="1.74981"
			/>
		</svg>
	);
}

export default PageIcon;
